export const environment = {
  apiUrl: 'https://dev-api.apollosystem.network',
  production: false,
  featureFlags: {
    datadog: {
      enabled: false,
      applicationId: '886dee6f-fbef-40ff-a4d3-fc23fa633d0e',
      clientToken: 'pubd337550e3f74fc489dc2df259f1caa79',
      site: 'us5.datadoghq.com',
      env: 'development',
    },
  },
  websocketUrl: 'https://dev-websockets.apollosystem.network',
}
